<template>
  <IntroComponent />
  <EducationComponent />
  <SkillComponent />
  <ProjectComponent />
  <CertiComponent />
</template>

<script>
import SkillComponent from "@/components/SkillComponent.vue";
import ProjectComponent from "@/components/ProjectComponent.vue";
import CertiComponent from "@/components/CertiComponent.vue";
import IntroComponent from "@/components/IntroComponent.vue";
import EducationComponent from "@/components/EducationComponent.vue";

export default {
  name: "HomePage",
  components: {
    SkillComponent,
    ProjectComponent,
    CertiComponent,
    IntroComponent,
    EducationComponent,
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Acme&family=Lato:wght@300;400;700&display=swap");
</style>
